export type ProfileIncompleteError = Error & {
	code: 'PROFILE_INCOMPLETE'
	status: 404
}

export const createProfileIncompleteError = (
	message: string
): ProfileIncompleteError => {
	const error = new Error(message) as ProfileIncompleteError
	error.code = 'PROFILE_INCOMPLETE'
	error.status = 404
	return error
}
